exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[class*=\"col\"] {\n  min-height: 100vh;\n  background: white;\n}\n\n.left-col {\n  background: #e4f7f1;\n  color: #00a887;\n}\n\nsmall, .highlight {\n  color: #00a887;\n}\n\nh1 {\n  margin-bottom: 0;\n}\n\na, a:hover, a:focus{\n  color: #00a887;\n}\n\n.content {\n  width: 65%;\n  margin: auto;\n}\n\nsmall {\n  font-size: 70%;\n}\n\n@media (max-width: 767px) {\n  .content {\n    width: 80%;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/app/results/regus/regus.component.css
// module id = ../../../../../src/app/results/regus/regus.component.css
// module chunks = main